__turbopack_context__.v({
  "blockCardTrioInline": "BlockCardTrioInline-module-scss-module__oCH55a__blockCardTrioInline",
  "cards": "BlockCardTrioInline-module-scss-module__oCH55a__cards",
  "flushBottom": "BlockCardTrioInline-module-scss-module__oCH55a__flushBottom",
  "flushTop": "BlockCardTrioInline-module-scss-module__oCH55a__flushTop",
  "inner": "BlockCardTrioInline-module-scss-module__oCH55a__inner",
  "listItem": "BlockCardTrioInline-module-scss-module__oCH55a__listItem",
  "listItemGap": "BlockCardTrioInline-module-scss-module__oCH55a__listItemGap",
});
